import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import { companyProfile } from "../../../api";
import { useAuth } from "../../../contexts/AuthContext";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
const url = process.env.REACT_APP_SOCKET_URL || window.location.origin;

function WhatsAppLogin() {
  console.log(url);
  const { config } = useAuth();
  const [qr, setQr] = useState(null);
  const [status, setStatus] = useState("Connecting...");
  const getSession = async () => {
    try {
      const response = await companyProfile.getWhatsappSession(config?.id);
      if (response.ok) {
        const data = await response.json();
      } else {
        setStatus("Failed to retrieve session");
      }
    } catch (error) {
      console.error("Error fetching session:", error);
      setStatus("Please Wait, Connecting...");
    }
  };
  useEffect(() => {
    if (!config?.id) return;
    const socket = io(url, {
      path: "/api/socket.io",
      transports: ["websocket"],
    });

    socket.on("connect", () => {
      console.log("Connected:", socket.id);
      socket.emit("join-room", config.id);
    });

    socket.on("qr", ({ qr }) => {
      console.log("Received QR:", qr);
      setQr(qr);
      setStatus("Scan the QR Code");
    });

    socket.on("authenticated", () => {
      console.log("Authenticated");
      setQr(null);
      setStatus("Authenticated ✅");
    });

    socket.on("logged_out", () => {
      console.log("Logged out");
      setQr(null);
      setStatus("Logged out. Please refresh to scan again.");
    });
    getSession();
    return () => {
      socket.disconnect();
    };
  }, [config?.id]);

  return (
    <div className="row gx-4">
      <div class="col-lg-4">
        <Card className="mb-4">
          <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            Whatsapp Gateway
          </CardHeader>
          <CardBody className={"my-1 text-center"}>
            <h3>{status}</h3>
            {qr && <img src={qr} alt="QR Code" />}
            <div className={"my-1 text-center"}>
              <button onClick={getSession} className="btn btn-theme">
                <i class="fa fa-refresh"></i>
                Refresh
              </button>
              <button
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you want to logout? You will need to rescan the QR code."
                    )
                  ) {
                    const socket = io(url, {
                      path: "/api/socket.io",
                      transports: ["websocket"],
                    });
                    socket.emit("logout", config.id);
                    setStatus("Logging out...");
                  }
                }}
                className="btn btn-danger ms-2"
              >
                <i class="fa fa-sign-out"></i>
                Logout
              </button>
            </div>
          </CardBody>
          <CardFooter>
            It can take a few seconds to connect, please wait until the status
            is Activated or the QR Shown
          </CardFooter>
        </Card>
      </div>
      <div class="col-lg-8">
        <Card className="mb-4">
          <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            Guidance How To Activate
          </CardHeader>
          <CardBody>
            <div>
              Tap on three dot on the top right whatsapp to open the option, and
              click <b className={"text-info"}>Linked devices</b>{" "}
            </div>
            <img
              src="/assets/img/whatsapp/linked.jpeg"
              style={{
                width: "150px",
                border: "1px solid white",
                padding: "4px",
              }}
              alt=""
            />
            <hr />

            <div>
              Then Click <b className={"text-info"}>Link a device</b> to scan
              the QR
            </div>

            <img
              src="/assets/img/whatsapp/scan.jpeg"
              style={{
                width: "150px",
                border: "1px solid white",
                padding: "4px",
              }}
              alt=""
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default WhatsAppLogin;
